import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setTeleconsultationUserDoctorMeetDetails } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import axios from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useTeleconsultationUserDoctorMeetDetailsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (booking_id: string) => {
      try {
        const response = await axios.get(
          `${PATIENT_WAITING_LIST?.TELECONSULTATION_USER_DOCTOR_MEET_DETAILS?.baseURL}?booking_id=${booking_id}`,
          {
            headers: {
              "X-Internal-API-Key": "@#INTERNAL325547API32676$%KEY0982*#%kjdgewiuTYIIBI876",
              "Content-Type": "application/json",
            },
          },
        );
        if (response.data.status === true) {
          dispatch(setTeleconsultationUserDoctorMeetDetails({ data: response.data.data }));
          return response.data.data;
        } else {
          dispatch(setTeleconsultationUserDoctorMeetDetails({ data: null }));
          return null;
        }
      } catch (e: any) {
        if (axios.isAxiosError(e)) {
          sendCurl(e.config?.["curlCommand"]);
        } else {
          // toast.error("Unexpected error: " + e.message);
        }
        // captureError(e);
        return null;
      }
    },
    [dispatch, sendCurl],
  );

  return execute;
};
